// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Focus Catcher — Game Styles ──────────────────────────────────────── */

.focus-catcher-page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #0A0A2E;
    color: #FFFFFF;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    overflow: hidden;
}

.focus-catcher-page.results-page {
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ─── Game Container ─────────────────────────────────────────────────── */

.game-container {
    position: fixed;
    inset: 0;
    background: #0A0A2E;
}

.game-canvas {
    display: block;
}

/* ─── HUD ────────────────────────────────────────────────────────────── */

.game-hud {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    z-index: 10;
}

.game-hud-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: env(safe-area-inset-top, 8px) 16px 0;
    height: 48px;
}

.game-hud-left {
    flex: 1;
}

.game-hud-center {
    flex: 0 0 auto;
    text-align: center;
}

.game-hud-right {
    flex: 1;
    text-align: right;
}

.game-score {
    font-size: 20px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.9);
    text-shadow: 0 0 8px rgba(0, 229, 255, 0.3);
}

.game-combo {
    font-size: 18px;
    font-weight: 700;
    color: #00FF88;
    transition: transform 0.15s ease-out;
}

.game-combo.combo-fire {
    color: #FFD700;
    text-shadow: 0 0 12px rgba(255, 215, 0, 0.5);
}

.pause-button {
    pointer-events: auto;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
    padding: 8px 12px;
    border-radius: 8px;
    min-width: 44px;
    min-height: 44px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.pause-button:hover {
    background: rgba(255, 255, 255, 0.15);
}

/* Game timer for timed modes */
.game-timer {
    text-align: center;
    padding: 4px 0;
    font-size: 22px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.7);
}

.timer-urgent {
    color: #FF3344;
    animation: timerPulse 0.5s ease-in-out infinite alternate;
}

@keyframes timerPulse {
    from { opacity: 1; }
    to { opacity: 0.5; }
}

/* Wave progress bar */
.game-wave-bar {
    height: 3px;
    background: rgba(255, 255, 255, 0.08);
    margin: 0 16px;
}

.game-wave-fill {
    height: 100%;
    background: #00E5FF;
    transition: width 0.3s ease;
    border-radius: 2px;
}

.game-hud-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    padding: 8px 16px;
    padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
    font-size: 12px;
    color: rgba(255, 255, 255, 0.4);
}

/* ─── Pause Overlay ──────────────────────────────────────────────────── */

.pause-overlay {
    position: fixed;
    inset: 0;
    background: rgba(10, 10, 46, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
    pointer-events: auto;
}

.pause-content {
    text-align: center;
}

.pause-title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 32px;
}

.pause-resume-btn {
    display: block;
    width: 200px;
    margin: 0 auto 16px;
    padding: 14px 24px;
    font-size: 18px;
    font-weight: 600;
    background: #00E5FF;
    color: #0A0A2E;
    border: none;
    border-radius: 12px;
    cursor: pointer;
}

.pause-quit-btn {
    display: block;
    color: rgba(255, 255, 255, 0.5);
    text-decoration: none;
    font-size: 14px;
    margin-top: 12px;
}

/* ─── Level Select ───────────────────────────────────────────────────── */

.level-select {
    padding: 16px;
    padding-top: calc(16px + env(safe-area-inset-top, 0px));
    max-width: 500px;
    margin: 0 auto;
    min-height: 100vh;
    box-sizing: border-box;
}

.level-select-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
}

.level-back-btn {
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    font-size: 20px;
    padding: 8px;
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.level-select-title {
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    color: #00E5FF;
}

.level-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.level-card {
    position: relative;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 16px 8px 12px;
    text-align: center;
    cursor: pointer;
    color: #FFFFFF;
    transition: background 0.15s, transform 0.1s;
    -webkit-tap-highlight-color: transparent;
}

.level-card:hover:not(.locked) {
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.02);
}

.level-card:active:not(.locked) {
    transform: scale(0.97);
}

.level-card.locked {
    opacity: 0.35;
    cursor: not-allowed;
}

.level-number {
    font-size: 22px;
    font-weight: 700;
    color: #00E5FF;
    margin-bottom: 4px;
}

.level-card.locked .level-number {
    color: rgba(255, 255, 255, 0.3);
}

.level-name {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.level-stars {
    font-size: 14px;
    letter-spacing: 2px;
}

.star-filled {
    color: #FFD700;
}

.star-empty {
    color: rgba(255, 255, 255, 0.15);
}

.level-highscore {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.4);
    margin-top: 4px;
}

.level-lock {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: 12px;
}

.level-select-stats {
    text-align: center;
    margin-top: 24px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.4);
}

/* ─── Results Screen ─────────────────────────────────────────────────── */

.game-results {
    text-align: center;
    padding: 24px;
    max-width: 400px;
    width: 100%;
}

.results-stars {
    font-size: 36px;
    letter-spacing: 8px;
    margin-bottom: 8px;
}

.result-star {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.result-star.star-filled {
    color: #FFD700;
    text-shadow: 0 0 16px rgba(255, 215, 0, 0.5);
}

.result-star.star-empty {
    color: rgba(255, 255, 255, 0.12);
}

.results-title {
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 12px;
}

.results-record {
    background: rgba(255, 215, 0, 0.12);
    color: #FFD700;
    padding: 8px 16px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 16px;
}

.results-nearmiss {
    color: #4FC3F7;
    font-size: 14px;
    margin-bottom: 16px;
}

.results-stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 12px;
}

.results-stat {
    background: rgba(255, 255, 255, 0.06);
    border-radius: 10px;
    padding: 12px 8px;
}

.results-stat .stat-value {
    font-size: 22px;
    font-weight: 700;
    color: #FFFFFF;
}

.results-stat .stat-label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 2px;
}

.results-secondary {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 24px;
}

.results-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-bottom: 16px;
}

.results-btn {
    padding: 14px 28px;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    min-height: 48px;
    -webkit-tap-highlight-color: transparent;
}

.results-btn-primary {
    background: #00E5FF;
    color: #0A0A2E;
}

.results-btn-primary:active {
    transform: scale(0.96);
}

.results-btn-secondary {
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.8);
}

.results-btn-secondary:active {
    transform: scale(0.96);
}

.results-details-toggle {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.35);
    font-size: 12px;
    cursor: pointer;
    padding: 8px;
}

.results-details {
    margin-top: 8px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.3);
    line-height: 1.8;
}

.results-back-link {
    display: block;
    margin-top: 16px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.3);
    text-decoration: none;
}

/* ─── Achievements ──────────────────────────────────────────────────── */

.results-achievements {
    margin-top: 12px;
    margin-bottom: 8px;
}

.achievement-badge {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 215, 0, 0.08);
    border: 1px solid rgba(255, 215, 0, 0.2);
    border-radius: 10px;
    padding: 8px 14px;
    margin-bottom: 6px;
}

.achievement-icon {
    font-size: 18px;
    flex-shrink: 0;
}

.achievement-name {
    font-weight: 600;
    font-size: 13px;
    color: #FFD700;
}

.achievement-desc {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.4);
}

/* ─── Break Suggestion ───────────────────────────────────────────────── */

.break-suggestion {
    background: rgba(102, 187, 106, 0.1);
    border: 1px solid rgba(102, 187, 106, 0.2);
    border-radius: 8px;
    padding: 8px 14px;
    font-size: 12px;
    color: rgba(102, 187, 106, 0.8);
    margin-bottom: 16px;
}

/* ─── Special Modes ──────────────────────────────────────────────────── */

.special-modes {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
}

.special-mode-card {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 12px 16px;
    text-align: left;
    cursor: pointer;
    color: #FFFFFF;
    -webkit-tap-highlight-color: transparent;
    width: 100%;
}

.special-mode-card:active:not(.locked) {
    transform: scale(0.98);
}

.special-mode-card.locked {
    opacity: 0.35;
    cursor: not-allowed;
}

.special-mode-card.completed {
    border-color: rgba(102, 187, 106, 0.3);
}

.daily-card {
    border-color: rgba(255, 215, 0, 0.2);
}

.endless-card {
    border-color: rgba(0, 229, 255, 0.2);
}

.special-mode-icon {
    font-size: 24px;
    flex-shrink: 0;
}

.special-mode-info {
    flex: 1;
}

.special-mode-name {
    font-weight: 600;
    font-size: 14px;
}

.special-mode-desc {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 2px;
}

.special-mode-badge {
    background: rgba(102, 187, 106, 0.2);
    color: #66BB6A;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
}

/* ─── Level Select Scrollable ────────────────────────────────────────── */

.level-select {
    overflow-y: auto;
}

/* ─── Mobile ─────────────────────────────────────────────────────────── */

@media (max-width: 380px) {
    .level-grid {
        gap: 8px;
    }
    .level-card {
        padding: 12px 6px 10px;
    }
    .level-number {
        font-size: 18px;
    }
    .results-stats-grid {
        gap: 8px;
    }
    .results-stat .stat-value {
        font-size: 18px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FocusCatcher.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,sEAAsE;IACtE,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,2EAA2E;;AAE3E;IACI,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,2EAA2E;;AAE3E;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,6CAA6C;IAC7C,YAAY;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,oBAAoB;IACpB,oCAAoC;IACpC,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;AACzC;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,yDAAyD;AAC7D;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,YAAY,EAAE;AACvB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,4DAA4D;IAC5D,eAAe;IACf,+BAA+B;AACnC;;AAEA,2EAA2E;;AAE3E;IACI,eAAe;IACf,QAAQ;IACR,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA,2EAA2E;;AAE3E;IACI,aAAa;IACb,uDAAuD;IACvD,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,4CAA4C;IAC5C,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;AACnC;;AAEA,2EAA2E;;AAE3E;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA,0EAA0E;;AAE1E;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA,2EAA2E;;AAE3E;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA,2EAA2E;;AAE3E;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,2EAA2E;;AAE3E;IACI,gBAAgB;AACpB;;AAEA,2EAA2E;;AAE3E;IACI;QACI,QAAQ;IACZ;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;IACA;QACI,QAAQ;IACZ;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* ─── Focus Catcher — Game Styles ──────────────────────────────────────── */\n\n.focus-catcher-page {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #0A0A2E;\n    color: #FFFFFF;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n    overflow: hidden;\n}\n\n.focus-catcher-page.results-page {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* ─── Game Container ─────────────────────────────────────────────────── */\n\n.game-container {\n    position: fixed;\n    inset: 0;\n    background: #0A0A2E;\n}\n\n.game-canvas {\n    display: block;\n}\n\n/* ─── HUD ────────────────────────────────────────────────────────────── */\n\n.game-hud {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    pointer-events: none;\n    z-index: 10;\n}\n\n.game-hud-top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: env(safe-area-inset-top, 8px) 16px 0;\n    height: 48px;\n}\n\n.game-hud-left {\n    flex: 1;\n}\n\n.game-hud-center {\n    flex: 0 0 auto;\n    text-align: center;\n}\n\n.game-hud-right {\n    flex: 1;\n    text-align: right;\n}\n\n.game-score {\n    font-size: 20px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.9);\n    text-shadow: 0 0 8px rgba(0, 229, 255, 0.3);\n}\n\n.game-combo {\n    font-size: 18px;\n    font-weight: 700;\n    color: #00FF88;\n    transition: transform 0.15s ease-out;\n}\n\n.game-combo.combo-fire {\n    color: #FFD700;\n    text-shadow: 0 0 12px rgba(255, 215, 0, 0.5);\n}\n\n.pause-button {\n    pointer-events: auto;\n    background: rgba(255, 255, 255, 0.1);\n    border: none;\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 16px;\n    padding: 8px 12px;\n    border-radius: 8px;\n    min-width: 44px;\n    min-height: 44px;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.pause-button:hover {\n    background: rgba(255, 255, 255, 0.15);\n}\n\n/* Game timer for timed modes */\n.game-timer {\n    text-align: center;\n    padding: 4px 0;\n    font-size: 22px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.7);\n}\n\n.timer-urgent {\n    color: #FF3344;\n    animation: timerPulse 0.5s ease-in-out infinite alternate;\n}\n\n@keyframes timerPulse {\n    from { opacity: 1; }\n    to { opacity: 0.5; }\n}\n\n/* Wave progress bar */\n.game-wave-bar {\n    height: 3px;\n    background: rgba(255, 255, 255, 0.08);\n    margin: 0 16px;\n}\n\n.game-wave-fill {\n    height: 100%;\n    background: #00E5FF;\n    transition: width 0.3s ease;\n    border-radius: 2px;\n}\n\n.game-hud-bottom {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: space-between;\n    padding: 8px 16px;\n    padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.4);\n}\n\n/* ─── Pause Overlay ──────────────────────────────────────────────────── */\n\n.pause-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(10, 10, 46, 0.9);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 20;\n    pointer-events: auto;\n}\n\n.pause-content {\n    text-align: center;\n}\n\n.pause-title {\n    font-size: 32px;\n    font-weight: 700;\n    margin-bottom: 32px;\n}\n\n.pause-resume-btn {\n    display: block;\n    width: 200px;\n    margin: 0 auto 16px;\n    padding: 14px 24px;\n    font-size: 18px;\n    font-weight: 600;\n    background: #00E5FF;\n    color: #0A0A2E;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n}\n\n.pause-quit-btn {\n    display: block;\n    color: rgba(255, 255, 255, 0.5);\n    text-decoration: none;\n    font-size: 14px;\n    margin-top: 12px;\n}\n\n/* ─── Level Select ───────────────────────────────────────────────────── */\n\n.level-select {\n    padding: 16px;\n    padding-top: calc(16px + env(safe-area-inset-top, 0px));\n    max-width: 500px;\n    margin: 0 auto;\n    min-height: 100vh;\n    box-sizing: border-box;\n}\n\n.level-select-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.level-back-btn {\n    color: rgba(255, 255, 255, 0.7);\n    text-decoration: none;\n    font-size: 20px;\n    padding: 8px;\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.level-select-title {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0;\n    color: #00E5FF;\n}\n\n.level-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n}\n\n.level-card {\n    position: relative;\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    padding: 16px 8px 12px;\n    text-align: center;\n    cursor: pointer;\n    color: #FFFFFF;\n    transition: background 0.15s, transform 0.1s;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.level-card:hover:not(.locked) {\n    background: rgba(255, 255, 255, 0.1);\n    transform: scale(1.02);\n}\n\n.level-card:active:not(.locked) {\n    transform: scale(0.97);\n}\n\n.level-card.locked {\n    opacity: 0.35;\n    cursor: not-allowed;\n}\n\n.level-number {\n    font-size: 22px;\n    font-weight: 700;\n    color: #00E5FF;\n    margin-bottom: 4px;\n}\n\n.level-card.locked .level-number {\n    color: rgba(255, 255, 255, 0.3);\n}\n\n.level-name {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.6);\n    margin-bottom: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.level-stars {\n    font-size: 14px;\n    letter-spacing: 2px;\n}\n\n.star-filled {\n    color: #FFD700;\n}\n\n.star-empty {\n    color: rgba(255, 255, 255, 0.15);\n}\n\n.level-highscore {\n    font-size: 10px;\n    color: rgba(255, 255, 255, 0.4);\n    margin-top: 4px;\n}\n\n.level-lock {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    font-size: 12px;\n}\n\n.level-select-stats {\n    text-align: center;\n    margin-top: 24px;\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.4);\n}\n\n/* ─── Results Screen ─────────────────────────────────────────────────── */\n\n.game-results {\n    text-align: center;\n    padding: 24px;\n    max-width: 400px;\n    width: 100%;\n}\n\n.results-stars {\n    font-size: 36px;\n    letter-spacing: 8px;\n    margin-bottom: 8px;\n}\n\n.result-star {\n    transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.result-star.star-filled {\n    color: #FFD700;\n    text-shadow: 0 0 16px rgba(255, 215, 0, 0.5);\n}\n\n.result-star.star-empty {\n    color: rgba(255, 255, 255, 0.12);\n}\n\n.results-title {\n    font-size: 22px;\n    font-weight: 700;\n    margin: 0 0 12px;\n}\n\n.results-record {\n    background: rgba(255, 215, 0, 0.12);\n    color: #FFD700;\n    padding: 8px 16px;\n    border-radius: 8px;\n    font-weight: 600;\n    font-size: 14px;\n    margin-bottom: 16px;\n}\n\n.results-nearmiss {\n    color: #4FC3F7;\n    font-size: 14px;\n    margin-bottom: 16px;\n}\n\n.results-stats-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.results-stat {\n    background: rgba(255, 255, 255, 0.06);\n    border-radius: 10px;\n    padding: 12px 8px;\n}\n\n.results-stat .stat-value {\n    font-size: 22px;\n    font-weight: 700;\n    color: #FFFFFF;\n}\n\n.results-stat .stat-label {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.5);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-top: 2px;\n}\n\n.results-secondary {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.4);\n    margin-bottom: 24px;\n}\n\n.results-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    margin-bottom: 16px;\n}\n\n.results-btn {\n    padding: 14px 28px;\n    font-size: 16px;\n    font-weight: 600;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    min-height: 48px;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.results-btn-primary {\n    background: #00E5FF;\n    color: #0A0A2E;\n}\n\n.results-btn-primary:active {\n    transform: scale(0.96);\n}\n\n.results-btn-secondary {\n    background: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.8);\n}\n\n.results-btn-secondary:active {\n    transform: scale(0.96);\n}\n\n.results-details-toggle {\n    background: none;\n    border: none;\n    color: rgba(255, 255, 255, 0.35);\n    font-size: 12px;\n    cursor: pointer;\n    padding: 8px;\n}\n\n.results-details {\n    margin-top: 8px;\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.3);\n    line-height: 1.8;\n}\n\n.results-back-link {\n    display: block;\n    margin-top: 16px;\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.3);\n    text-decoration: none;\n}\n\n/* ─── Achievements ──────────────────────────────────────────────────── */\n\n.results-achievements {\n    margin-top: 12px;\n    margin-bottom: 8px;\n}\n\n.achievement-badge {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(255, 215, 0, 0.08);\n    border: 1px solid rgba(255, 215, 0, 0.2);\n    border-radius: 10px;\n    padding: 8px 14px;\n    margin-bottom: 6px;\n}\n\n.achievement-icon {\n    font-size: 18px;\n    flex-shrink: 0;\n}\n\n.achievement-name {\n    font-weight: 600;\n    font-size: 13px;\n    color: #FFD700;\n}\n\n.achievement-desc {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.4);\n}\n\n/* ─── Break Suggestion ───────────────────────────────────────────────── */\n\n.break-suggestion {\n    background: rgba(102, 187, 106, 0.1);\n    border: 1px solid rgba(102, 187, 106, 0.2);\n    border-radius: 8px;\n    padding: 8px 14px;\n    font-size: 12px;\n    color: rgba(102, 187, 106, 0.8);\n    margin-bottom: 16px;\n}\n\n/* ─── Special Modes ──────────────────────────────────────────────────── */\n\n.special-modes {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 16px;\n}\n\n.special-mode-card {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    padding: 12px 16px;\n    text-align: left;\n    cursor: pointer;\n    color: #FFFFFF;\n    -webkit-tap-highlight-color: transparent;\n    width: 100%;\n}\n\n.special-mode-card:active:not(.locked) {\n    transform: scale(0.98);\n}\n\n.special-mode-card.locked {\n    opacity: 0.35;\n    cursor: not-allowed;\n}\n\n.special-mode-card.completed {\n    border-color: rgba(102, 187, 106, 0.3);\n}\n\n.daily-card {\n    border-color: rgba(255, 215, 0, 0.2);\n}\n\n.endless-card {\n    border-color: rgba(0, 229, 255, 0.2);\n}\n\n.special-mode-icon {\n    font-size: 24px;\n    flex-shrink: 0;\n}\n\n.special-mode-info {\n    flex: 1;\n}\n\n.special-mode-name {\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.special-mode-desc {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.5);\n    margin-top: 2px;\n}\n\n.special-mode-badge {\n    background: rgba(102, 187, 106, 0.2);\n    color: #66BB6A;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 4px;\n}\n\n/* ─── Level Select Scrollable ────────────────────────────────────────── */\n\n.level-select {\n    overflow-y: auto;\n}\n\n/* ─── Mobile ─────────────────────────────────────────────────────────── */\n\n@media (max-width: 380px) {\n    .level-grid {\n        gap: 8px;\n    }\n    .level-card {\n        padding: 12px 6px 10px;\n    }\n    .level-number {\n        font-size: 18px;\n    }\n    .results-stats-grid {\n        gap: 8px;\n    }\n    .results-stat .stat-value {\n        font-size: 18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
